import { render, staticRenderFns } from "./OrderCollectionOnDehalf.vue?vue&type=template&id=26b74450&scoped=true"
import script from "./OrderCollectionOnDehalf.vue?vue&type=script&lang=js"
export * from "./OrderCollectionOnDehalf.vue?vue&type=script&lang=js"
import style0 from "./OrderCollectionOnDehalf.vue?vue&type=style&index=0&id=26b74450&prod&lang=scss&scoped=true"
import style1 from "./OrderCollectionOnDehalf.vue?vue&type=style&index=1&id=26b74450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b74450",
  null
  
)

export default component.exports